import * as React from 'react'

const DocumentTextIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)" fill={props.fill}>
      <path d="M12 17.063H6c-2.737 0-4.313-1.575-4.313-4.313v-7.5C1.688 2.513 3.264.937 6 .937h6c2.738 0 4.313 1.576 4.313 4.313v7.5c0 2.738-1.575 4.313-4.313 4.313Zm-6-15c-2.145 0-3.188 1.042-3.188 3.187v7.5c0 2.145 1.043 3.188 3.188 3.188h6c2.145 0 3.188-1.043 3.188-3.188v-7.5c0-2.145-1.043-3.188-3.188-3.188H6Z" />
      <path d="M13.875 6.938h-1.5a2.061 2.061 0 0 1-2.063-2.063v-1.5c0-.308.256-.563.563-.563.307 0 .563.256.563.563v1.5c0 .518.42.938.937.938h1.5c.307 0 .563.255.563.562a.567.567 0 0 1-.563.563ZM9 10.313H6a.567.567 0 0 1-.563-.563c0-.307.255-.563.563-.563h3c.307 0 .563.256.563.563a.567.567 0 0 1-.563.563ZM12 13.313H6a.567.567 0 0 1-.563-.563c0-.307.255-.563.563-.563h6c.307 0 .563.256.563.563a.567.567 0 0 1-.563.563Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)

DocumentTextIcon.defaultProps = {
  height: 18,
  width: 18,
  fill: '#64748B'
}

export { DocumentTextIcon }
